module.exports = __webpack_public_path__ + "img/getboarded.8973a816.svg";